import { Box } from '@mui/material'
import React, { ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SearchField from 'ui/atoms/SearchField/SearchField'
import styles from './ToggleMenu.module.less'
import ToggleMenuTab from './ToggleMenuTab/ToggleMenuTab'

type ToggleMenuProps = {
  title: string
  menuWidth: number
  headerHeight: number
  icon?: string
  number: number
  tooltipLabel?: string
  children: (searchTerm: string) => React.ReactNode
  onToggle: (isOpen: boolean) => void
}

export default function ToggleMenu({
  title,
  menuWidth,
  headerHeight,
  icon,
  number,
  tooltipLabel,
  children,
  onToggle,
}: ToggleMenuProps): ReactElement {
  const { t } = useTranslation()

  const [searchTerm, setSearchTerm] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleMenuToggle = useCallback(
    (isOpen: boolean) => {
      setIsMenuOpen(isOpen)
      onToggle(isOpen)
    },
    [onToggle]
  )

  return (
    <>
      <ToggleMenuTab
        number={number}
        menuWidth={menuWidth}
        tooltipLabel={tooltipLabel}
        icon={icon}
        onToggle={handleMenuToggle}
      />
      {isMenuOpen && (
        <Box sx={{ width: `${menuWidth}%`, height: `calc(100vh - ${headerHeight}px)` }}>
          <div className={styles.ToggleMenu}>
            <div className={styles.ToggleMenu_Header}>{t(title)}</div>
            <div className={styles.ToggleMenu_Search}>
              <SearchField
                value={searchTerm}
                onChange={(value) => setSearchTerm(String(value))}
                onClear={() => setSearchTerm('')}
                onDarkBackground
              />
            </div>
            {children(searchTerm)}
          </div>
        </Box>
      )}
    </>
  )
}
